import { Swiper } from 'swiper';
import { A11y, Navigation, Pagination } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-card-image-slider .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider, index) => {
		slider.parentElement.classList.add(
			`block-card-image-slider__swiper--${index}`
		);

		const settings = {
			//loop: slides.length > 1 ? true : false,
			grabCursor: true,
			spaceBetween: 32,
			slidesPerView: 1,
			modules: [A11y, Navigation, Pagination],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 3,
				},
			},
			navigation: {
				prevEl: `.block-card-image-slider__swiper--${index} .swiper-button-prev`,
				nextEl: `.block-card-image-slider__swiper--${index} .swiper-button-next`,
			},
			pagination: {
				el: `.block-card-image-slider__swiper--${index} .swiper-pagination`,
				clickable: true,
			},
		};

		new Swiper(slider, settings);
	});
}
